import { CartPolicyMeta, TaggedPolicy } from './types';
import { duplicateLinePolicy } from './duplicateLine.policy';
import { maxQuantityPolicy } from './maxQuantity.policy';
import { uhxAutoAddPolicy } from './uhxAutoAdd.policy';
import { deriveDiscountCodesPolicy } from './deriveDiscountCodes.policy';
import { cartSourcePolicy } from './cartSource.policy';
import { usBvRegionSwapPolicy } from './usBvRegionSwap.policy';
import { siblingIdIncrementPolicy } from './siblingIdIncrement.policy';
import { bundleRemovalPolicy } from './bundleRemoval.policy';
import { uhxRemovalDiscountPolicy } from './uhxRemovalDiscount.policy';
import { uhxCompanionRemovalPolicy } from './uhxCompanionRemoval.policy';
import { uhxTwoItemCartPolicy } from './uhxTwoItemCart.policy';
import { sizingKitBundlePolicy } from './sizingKitBundle.policy';

const onAdd = (meta: CartPolicyMeta) => meta.flow === 'add' || !meta.flow;
const onRemove = (meta: CartPolicyMeta) => meta.flow === 'remove';

// Order matters: `uhxAutoAdd` must precede `deriveDiscountCodes`, and
// `sizingKitBundle` must stay first — see docs/cart-sizing-kit-policy.md.
export const cartPolicies: TaggedPolicy[] = [
  { name: 'sizingKitBundle', scope: 'shared', policy: sizingKitBundlePolicy, appliesTo: onAdd },
  { name: 'duplicateLine', scope: 'client', policy: duplicateLinePolicy, appliesTo: onAdd },
  { name: 'maxQuantity', scope: 'client', policy: maxQuantityPolicy, appliesTo: onAdd },
  { name: 'uhxAutoAdd', scope: 'shared', policy: uhxAutoAddPolicy, appliesTo: onAdd },
  { name: 'deriveDiscountCodes', scope: 'shared', policy: deriveDiscountCodesPolicy },
  { name: 'cartSource', scope: 'shared', policy: cartSourcePolicy, appliesTo: onAdd },
  { name: 'usBvRegionSwap', scope: 'shared', policy: usBvRegionSwapPolicy, appliesTo: onAdd },
  { name: 'siblingIdIncrement', scope: 'client', policy: siblingIdIncrementPolicy, appliesTo: onAdd },
  { name: 'bundleRemoval', scope: 'shared', policy: bundleRemovalPolicy, appliesTo: onRemove },
  { name: 'uhxRemovalDiscount', scope: 'shared', policy: uhxRemovalDiscountPolicy, appliesTo: onRemove },
  { name: 'uhxCompanionRemoval', scope: 'shared', policy: uhxCompanionRemovalPolicy, appliesTo: onRemove },
  { name: 'uhxTwoItemCart', scope: 'shared', policy: uhxTwoItemCartPolicy, appliesTo: onRemove },
];
